import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { AddallowancepopupComponent } from '../generalpopup/addallowancepopup/addallowancepopup.component';
import { AdddeductionpopupComponent } from '../generalpopup/adddeductionpopup/adddeductionpopup.component';

@Component({
  selector: 'app-emppay',
  templateUrl: './emppay.component.html',
  styleUrls: ['./emppay.component.css']
})
export class EmppayComponent implements OnInit {
  userBO:any={};
  userrolerightsColl:any=[];
  userView: any = {};

  payrolltype: string = "";

  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService,
    private productFindService: NgbModal, ) { 
     
  }
  
   
  

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  emppayform = new FormGroup({
    allowanceid: new FormControl(0),
    deductionid: new FormControl(0),
    amount: new FormControl(0, Validators.required),
    isexcludedfromwps: new FormControl(false),
  });

  //Edit Get Values
  allowanceColl: any = [];
  deductionColl: any = [];

  @Input() emppayid: any = 0;
  @Input() allowanceid: any = null
  @Input() amount: any = null;
  @Input() deductionid: any = null;
  @Input() paytype: string = ""
  @Input() isexcludedfromwps: any = false;



  @Output() emitData = new EventEmitter();


  ngOnInit() {
    this.userBO = this.loginService.userBO      
    this.payrolltype = this.userBO.payrolltype

    this.emppayform.reset();
    this.fnInitializeFormGroup();
    this.fngetAllowance();
    this.fngetDeduction();
  }


  fnInitializeFormGroup() {
    this.emppayform.setValue({
      allowanceid: this.allowanceid,
      deductionid: this.deductionid,
      amount: this.amount,
      isexcludedfromwps: this.isexcludedfromwps,
    })
  }

  //Get 
  fngetAllowance() {
    var data = {
      'allowanceid': 0,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getAllowance(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.allowanceColl = res.json().result;
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetDeduction() {
    var data = {
      'deductionid': 0,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getDeduction(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.deductionColl = res.json().result;
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.emppayform.valid) {

        // const index = this.allowanceColl.findIndex(sku => sku.allowanceid === this.emppayform.get('allowanceid').value); 

        //Check
        var data = {
          emppayid: this.emppayid,
          allowanceid: this.emppayform.get('allowanceid').value,
          // allowancename: this.allowanceColl[index].allowancename,
          deductionid: this.emppayform.get('deductionid').value,
          amount: this.emppayform.get('amount').value,
          isexcludedfromwps: this.emppayform.get('isexcludedfromwps').value,
        }
        this.emitData.emit(data);
        this.activeModal.close(true);

      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnUpdatePayType() {
    if (this.paytype === 'ALLOWANCE') {
      this.emppayform.controls['allowanceid'].setValidators(Validators.required);
    }
    else if (this.paytype === 'DEDUCTION') {
      this.emppayform.controls['deductionid'].setValidators(Validators.required);
    }

  }
//AddAllowance
private fnAddAllowance() {

  const modalRef = this.productFindService.open(AddallowancepopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetAllowance();

    if (receivedEntry > 0) {
      this.emppayform.patchValue({ allowanceid: receivedEntry })
    }
  });

}
//AddDeduction
private fnAddDeduction() {

  const modalRef = this.productFindService.open(AdddeductionpopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetDeduction();

    if (receivedEntry > 0) {
      this.emppayform.patchValue({ deductionid: receivedEntry })
    }
  });

}
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }



}
